import * as React from 'react';
import BuildButtons from './build-buttons';
import { connect } from 'react-redux';
import { AppState } from '@om-fe/core/core/types';
import {
    MatchListStoreModel,
    FilteredMainMarkets,
} from '../match-list/utils/match-list-models';
import { marketsIdsToDisplayOddsParamBetweenOdds, marketsIdsToDisplayOddsParamFor } from '../match-list/utils/match-list.constants';
import getSlice from '@om-fe/core/utils/get-slice';
import { BemMethod } from '@om-fe/utils';
import { ModelTypes } from '@om-fe/models';

export interface OddsGroupPublicProps {
    readonly mainMarketId: string;
    readonly matchId: string;
    readonly sliceKey: string;
    readonly inheritedBem: BemMethod;
    readonly showOddsBar?: boolean;
    readonly modelType: ModelTypes;
    readonly hasLabelResponse: string | undefined;
}

export interface OddsGroupStoreProps {
    readonly filteredMainMarket?: FilteredMainMarkets;
}

export type OddsGroupProps = OddsGroupPublicProps & OddsGroupStoreProps;

class OddsGroupComponent extends React.PureComponent<OddsGroupProps> {
    constructor(props: OddsGroupProps) {
        super(props);
        this.state = {
            hasLabelResponse: props.hasLabelResponse
        };
    }
    getHasLabel = (hasLabelResponse: string | undefined) => {
        this.setState({ hasLabelResponse });
    }
    render() {
        const { filteredMainMarket, matchId, sliceKey, inheritedBem, showOddsBar, modelType } = this.props;

        if (!filteredMainMarket) {
            return null;
        }
        const hasLabel = this.state.hasLabelResponse;
        const { bettingTypeId, eventPartId, numberOfOutcomes, id, hasSelector } = filteredMainMarket;
        
        return (
            <div
                className={inheritedBem(
                    'ButtonsGroup',
                    {
                        [hasLabel && 'HasLabel']: hasLabel && true,
                        [bettingTypeId]: true,
                        [`Column-${numberOfOutcomes}`]: true,
                        HasParameterInside:
                            marketsIdsToDisplayOddsParamFor.includes(bettingTypeId),
                        HasParameterOutside:
                            marketsIdsToDisplayOddsParamBetweenOdds.includes(bettingTypeId),
                    },
                )}
                key={`btnGrp_${matchId}_${id}`}
            >
                <BuildButtons
                    bettingTypeId={bettingTypeId}
                    eventId={matchId}
                    sliceKey={sliceKey}
                    groupId={hasSelector ? id : undefined}
                    key={matchId}
                    eventPartId={eventPartId}
                    numberOfOutcomes={numberOfOutcomes}
                    elemIndex={1}
                    elemToBeAdded={<span key={bettingTypeId} className="OddsParameter" />}
                    showOddsBar={showOddsBar}
                    modelType={modelType}
                    sendHasLabel={this.getHasLabel}
                />
            </div>
        );
    }
}

const OddsGroup: React.ComponentType<OddsGroupPublicProps> = connect<OddsGroupStoreProps>(
    (state: AppState, props: OddsGroupPublicProps): OddsGroupStoreProps => {
        const { sliceKey, mainMarketId } = props;
        
        const slice: MatchListStoreModel | undefined = getSlice<MatchListStoreModel>(state, sliceKey);

        if (!slice) {
            return {};
        }

        const { filteredMainMarkets } = slice;
        
        return {
            filteredMainMarket: filteredMainMarkets[mainMarketId],
        };
    },
)(OddsGroupComponent);

export default OddsGroup;
